module.exports = __webpack_public_path__ + "img/car.ead429c2.jpg";